<template>
    <div id="diagramm">
        <div class="klassenname">
            <input id="klassennameinput" @focus="select('class', klasse.name)" type="text" v-model.lazy="klasse.name">
        </div>

        <div class="attribute">
            <draggable v-model="klasse.fields">
                <div class="attribut" v-for="attribut in klasse.fields">
                    <input @focus="select('field', attribut)" type="text"
                           size="30"
                           :value="(attribut.name ? attribut.name : '') + (attribut.type ? ': '+attribut.type : '')"
                           @change="changeField" placeholder="attributname: datentyp">
                    <span class="remove" @click="removeField(attribut)">&cross;</span>
                    <span class="move">&#8691;</span>
                </div>
            </draggable>
            <div class="new" @click="createField">+</div>
        </div>

        <div class="methoden">
            <draggable v-model="klasse.methods">
                <div class="methode" v-for="methode in klasse.methods">
                    <input @focus="select('method', methode)" type="text"
                           size="30"
                           :value="methodeAlsUML(methode)"
                           @change="changeMethod"
                           placeholder="methodenname(param: typ, ...): rueckgabetyp">
                    <span class="remove" @click="removeMethod(methode)">&cross;</span>
                    <span class="move">&#8691;</span>
                </div>
            </draggable>
            <div class="new" @click="createMethod">+</div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        name: 'diagramm',
        props: ['klasse'],
        components: {
            draggable,
        },
        methods: {
            select(type, element) {
                this.klasse.selectionType = type;
                this.klasse.selected = element;
            },
            createField() {
                let field = {type: '', name: ''};
                this.klasse.fields.push(field);
                this.select('field', field);
            },
            createMethod() {
                let method = {returnType: '', name: '', parameters: []};
                this.klasse.methods.push(method);
                this.select('method', method);
            },
            removeField(element) {
                let index = this.klasse.fields.indexOf(element);
                this.klasse.fields.splice(index, 1);
                if (element === this.klasse.selected) {
                    this.klasse.selected = '';
                    this.klasse.selectionType = '';
                }
                window.focus();
            },
            removeMethod(element) {
                let index = this.klasse.methods.indexOf(element);
                this.klasse.methods.splice(index, 1);
                this.klasse.selected = this.klasse.name;
                this.klasse.selectionType = 'class';
            },
            changeField(event) {
                this.klasse.selected.name = event.target.value.split(':')[0].trim();
                if (event.target.value.split(':').length > 1)
                    this.klasse.selected.type = event.target.value.split(':')[1].trim();
                else
                    this.klasse.selected.type = '';
            },
            changeMethod(event) {
                let methodenteile = event.target.value.split(/\(|\)/);
                let methodenname = methodenteile[0].trim();
                this.klasse.selected.name = methodenname;
                if (methodenteile.length > 1) {
                    // Parameter verarbeiten
                    this.klasse.selected.parameters = [];
                    if (methodenteile[1] !== '') {
                        let parameter = methodenteile[1].split(',');
                        for (let p of parameter) {
                            let pName = p.split(':')[0].trim();
                            let pTyp = p.split(':')[1].trim();
                            this.klasse.selected.parameters.push({type: pTyp, name: pName});
                        }
                    }
                }
                else {
                    this.klasse.selected.methods = [];
                }
                if (methodenteile.length > 2) {
                    // Rückgabetyp verarbeiten
                    let rueckgabetyp = methodenteile[2].replace(':', '').trim();
                    if (methodenname == this.klasse.name && rueckgabetyp != '') {// ist Konstruktor mit Rückgabetyp?
                        this.klasse.selected.returnType = '';
                        alert("Konstruktoren haben keinen Rückgabetyp");
                    }
                    else {
                        this.klasse.selected.returnType = rueckgabetyp;
                    }
                }
                else {
                    this.klasse.selected.returnType = '';
                }
            },
            methodeAlsUML(methode) {
                if (methode.name === '')
                    return '';
                else {
                    let params = '';
                    for (let p of methode.parameters) {
                        params += p.name + ': ' + p.type + ', ';
                    }
                    // letztes Komma und Leerzeichen abschneiden
                    if (params.length > 0)
                        params = params.substr(0, params.length - 2);
                    return methode.name + '(' + params + ')' + (methode.returnType ? ': ' + methode.returnType : '');
                }
            }
        },
    }
</script>

<style scoped>
    #diagramm {
        min-width: 350px;
    }

    .attribute, .methoden, .klassenname {
        padding: 5px;
        box-shadow: 2px 0 0 0 #888,
        0 2px 0 0 #888,
        2px 2px 0 0 #888, /* Just to fix the corner */ 2px 0 0 0 #888 inset,
        0 2px 0 0 #888 inset;
    }

    .klassenname {
        text-align: center;
    }

    input {
        border: none;
    }

    .klassenname input {
        font-size: large;
        text-align: center;
    }

    .attribute input, .methoden input {
        font-size: medium;
        width: 87%;
    }

    .new {
        opacity: 0;
        text-align: center;
    }

    .new:hover {
        opacity: 0.5;
    }

    .remove, .move {
        opacity: 0.0;
    }

    .attribut:hover .remove, .methode:hover .remove, .attribut:hover .move, .methode:hover .move {
        opacity: 0.5;
    }
</style>



// WEBPACK FOOTER //
// Diagramm.vue?eec27856